import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SALES_SAGA } from "../sagaTypes";
import { loaderAction, allSalesCountAction, paginationAction, salesAction, totalSumAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_sales`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetSales(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('page', args?.data?.page || 1);
        formData.append('date_from', args?.data?.from || '');
        formData.append('date_to', args?.data?.to || '');
        formData.append('subscription_type', args?.data?.subscription_type || '');
        formData.append('subscription_coach', args?.data?.subscription_coach || '');
        formData.append('sales_type', args?.data?.sales_type || '');
        formData.append('payment_methods', args?.data?.payment_methods);
        formData.append('admins', args?.data?.admins);
        formData.append('min_sum', args?.data?.minSum || '');
        formData.append('max_sum', args?.data?.maxSum || '');
        formData.append('sales_user', args?.data?.sales_user || '');


        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(salesAction(response.sales));
            yield put(paginationAction(response.pagination));
            yield put(allSalesCountAction(response.all_sales_count));
            yield put(totalSumAction(response.total_sum));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetSales() {
    yield takeLatest(GET_SALES_SAGA, workerGetSales);
}